import { string } from 'yup';
import { BasePhoneEmailValidation } from './base-phone-email';

const RecontactFormValidation = BasePhoneEmailValidation.shape({
  firstName: string().required('validations.first_name.required'),
  lastName: string().required('validations.last_name.required'),
  message: string().optional().nullable(),
});

export default RecontactFormValidation;
